




































































import { ProfileVueGB } from "@/extensions/profile/ProfileVueGB";
import PersonalDataModal from "@/components/settings/PersonalDataModal.vue";
import AppSettingsModal from "@/components/settings/AppSettingsModal.vue";
import TransfersPhoneModal from "@/components/settings/TransfersPhoneModal.vue";
import ReferencesModal from "@/components/settings/ReferencesModal.vue";
import LoginSettingsModal from "@/components/settings/LoginSettingsModal.vue";
import CardLimitsModal from "@/components/cardOperations/CardLimitsModal.vue";
import SubscriptionList from "@/components/subscription/SubscriptionList.vue";
import DocumentsModal from "@/components/settings/DocumentsModal.vue";
import { Component } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";

@Component({
  components: {
    BackLink,
    SubscriptionList,
    PersonalDataModal,
    AppSettingsModal,
    TransfersPhoneModal,
    ReferencesModal,
    DocumentsModal,
    LoginSettingsModal,
    CardLimitsModal
  }
})
export default class Profile extends ProfileVueGB {
}
